import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  ApiError,
  getGetRespondentLinkReissueQueryKey,
  reissueRespondentLink,
  type RespondentsLinkReissueAccepted,
  type RespondentsLinkReissueRequest,
} from "@wellcheck/api-client";

/**
 * orval.config.ts の方針で mutation hook は生成しないため、低レベル関数を useMutation で包む
 * (useSubmitAnswers / useUpdateContact と同型)。
 * 成功後に対象確認を取り直さないと、画面が eligible のまま残り、送られない再送信を押せてしまう。
 */
export function useReissueLink() {
  const queryClient = useQueryClient();
  return useMutation<RespondentsLinkReissueAccepted, ApiError, RespondentsLinkReissueRequest>({
    mutationFn: async (input: RespondentsLinkReissueRequest) => {
      const response = await reissueRespondentLink(input);
      if (response.status !== 202) {
        throw new ApiError(response.status, response.data, response.headers);
      }
      return response.data;
    },
    onSuccess: (_data, input) =>
      queryClient.invalidateQueries({
        queryKey: getGetRespondentLinkReissueQueryKey(input),
      }),
  });
}
